import { render } from "./Index.vue?vue&type=template&id=2def7f82&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=2def7f82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2def7f82"

export default script